import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { RenderIf } from "shared/components";

export default function Index({ onChange, value, label }) {
  const toolbarOptions = [
    ["bold", "italic", "underline", "strike"],
    [{ header: 1 }, { header: 2 }],
    [{ align: "justify" }, { align: "center" }, { align: "right" }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["link", "formula"],
  ];

  return (
    <div>
      <RenderIf condition={label}>
        <label className="form-label font-500">{label}</label>
      </RenderIf>
      <ReactQuill
        onChange={onChange}
        value={value}
        modules={{
          toolbar: toolbarOptions,
        }}
        placeholder="Text..."
      />
    </div>
  );
}
